import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { D1TransactionsEdit } from "./edit";
import { D1TransactionsNew } from "./new";
import { D1TransactionsTable } from "./table";

export default function D1Transactions() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Transactions");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<D1TransactionsEdit />} />
      <Route index element={<D1TransactionsTable />} />
      <Route path="/new" element={<D1TransactionsNew />} />
    </Routes>
  );
}
